import React from 'react';
import { Sparkles, Database, ArrowRight, X } from 'lucide-react';

export default function SeedDataBanner({ onSeed, onDismiss, loading }) {
  return (
    <div className="p-6 rounded-2xl bg-gradient-to-r from-sky-950/60 via-indigo-950/60 to-slate-900 border border-sky-500/30 mb-8 shadow-xl relative overflow-hidden">
      <div className="absolute top-0 right-0 -mt-6 -mr-6 w-32 h-32 bg-sky-500/10 rounded-full blur-2xl pointer-events-none"></div>
      
      {/* Top right dismiss button */}
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="absolute top-3.5 right-3.5 p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800/80 transition z-20"
          title="Dismiss this recommendation"
        >
          <X className="w-4 h-4" />
        </button>
      )}

      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 relative z-10">
        <div className="flex items-start space-x-4 pr-6">
          <div className="p-3 rounded-2xl bg-gradient-to-tr from-sky-500 to-indigo-600 text-white shadow-lg shadow-sky-500/20 flex-shrink-0">
            <Sparkles className="w-6 h-6 animate-pulse" />
          </div>
          <div>
            <h3 className="text-base font-bold text-white">Initialize Protocol Stack</h3>
            <p className="text-xs text-slate-300 mt-1 max-w-xl">
              Your dataset is currently empty. Would you like to seed your database with baseline active protocol compounds (Supplements, Peptides & Hormones / AAS including Tirzepatide, Testosterone Enanthate, NMN, Tadalafil, GHK-Cu, DHEA)?
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-2 w-full md:w-auto justify-end">
          {onDismiss && (
            <button
              type="button"
              onClick={onDismiss}
              className="px-3.5 py-2.5 rounded-xl bg-slate-800/80 hover:bg-slate-700/80 text-slate-300 font-semibold text-xs border border-slate-700/80 transition whitespace-nowrap"
            >
              Dismiss
            </button>
          )}

          <button
            onClick={onSeed}
            disabled={loading}
            className="flex items-center space-x-2 px-5 py-2.5 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-400 hover:to-teal-500 text-slate-950 font-bold text-xs shadow-lg shadow-emerald-500/25 transition whitespace-nowrap"
          >
            <Database className="w-4 h-4" />
            <span>{loading ? 'Loading Sample Template...' : 'Load Sample Template'}</span>
            <ArrowRight className="w-4 h-4 ml-1" />
          </button>
        </div>
      </div>
    </div>
  );
}
